import axios from 'axios';
import { casinoLangPrefix } from 'utils/constants/app/general';
import { CasinoCommandNames } from 'utils/constants/casino/casino-command-names';
import { SUCCESS_STATUS_CODE } from 'utils/constants/swarm/backend-status-codes';
import SpringConfigs from 'utils/constants/swarm/spring-configs';
import { showToastError } from 'utils/generic/show-toast-error';
import { isMobile } from 'utils/is-mobile';
import {
  DecentralizedCasinoGamesFetchingParams,
  ENewCasinoGamesFetchingParamsKey,
  NewCasinoGameBackend,
  NewCasinoGamesFetchingParams
} from 'interfaces/new-casino';

export const fetchGamesByIds = (
  ids: string[],
  showErrorMessage = true,
  useExternalId = false,
  decentralized = false
): Promise<NewCasinoGameBackend[]> => {
  let _params:
    | DecentralizedCasinoGamesFetchingParams
    | NewCasinoGamesFetchingParams;

  if (decentralized) {
    _params = {
      partnerId: SpringConfigs.DECENTRALIZED_CASINO_PARTNER_ID,
      gameId: ids[0]
    };
  } else {
    _params = {
      partner_id: SpringConfigs.PARTNER_ID,
      is_mobile: Number(isMobile()),
      lang: casinoLangPrefix,
      by_key: ENewCasinoGamesFetchingParamsKey.Id,
      use_webp: Number(SpringConfigs.IS_WEBP_SUPPORTED),
      country: SpringConfigs.CURRENT_COUNTRY_CODE
    };

    if (useExternalId && ids?.length) {
      _params.external_id = ids;
    } else {
      if (ids?.length === 1) {
        _params.id = ids[0];
      } else if (ids?.length > 1) {
        _params.external_id = ids;
      } else {
        return new Promise(resolve => resolve([]));
      }
    }
  }

  const url = SpringConfigs?.DECENTRALIZED_CASINO_URL
    ? `${SpringConfigs.DECENTRALIZED_CASINO_URL}${CasinoCommandNames['GET_DECENTRALIZED_GAME']}`
    : `${SpringConfigs.CASINO_URL}/${CasinoCommandNames['GET_GAMES']}`;

  return axios
    .get<{
      games: NewCasinoGameBackend[];
      status: string;
    }>(url, {
      params: _params
    })
    .then((response: any) => {
      if (
        response.status === SUCCESS_STATUS_CODE &&
        response.data &&
        (response.data.status === 'ok' || decentralized)
      ) {
        return decentralized
          ? [
              {
                extearnal_game_id: response.data.externalGameId,
                types: {
                  realMode: 0,
                  funMode: 0
                },
                icon_1: response.data.icon1,
                icon_2: response.data.icon2,
                icon_3: response.data.icon3,
                provider: 'ALL',
                provider_badge: null,
                provider_title: 'ALL',
                show_as_provider: 'ALL',
                cats: response.data.categories,
                ...response.data
              }
            ]
          : Object.values(response.data.games);
      } else {
        if (showErrorMessage) {
          showToastError(response.statusText);
        }

        return [];
      }
    })
    .catch(error => {
      if (showErrorMessage) {
        showToastError(error.toString());
      }

      return [];
    });
};
